module.exports = require('./lib/uslug');